import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { RadioComponentDef } from '@df/ui/form/radio/radio.component.def';

@Component({
    selector: 'radio',
    templateUrl: 'radio.html',
    styleUrls: ['radio.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None
})
export class RadioComponent extends RadioComponentDef {
    @HostBinding('class.radio')
    getRadio = true;
}
